<template >

<nav>
  <v-toolbar flat app class="hidden-sm-and-down">

    <v-spacer></v-spacer>
    <v-btn flat color="indigo darken-1" @click="$vuetify.goTo('#about', {duration:1000})" to="/">
      About
    </v-btn>
    <v-btn flat color="indigo darken-1" @click="$vuetify.goTo('#research', {duration:1000})" to="/">
      Research Interests
    </v-btn>
    <v-btn flat color="indigo darken-1" @click="$vuetify.goTo('#publications', {duration:1000})" to="/">
      Publications
    </v-btn>
    <v-btn flat color="indigo darken-1" @click="$vuetify.goTo('#teaching', {duration:1000})" to="/">
      Teaching Experience
    </v-btn>
    <!--<v-btn flat color="indigo darken-1" to="/job-market">
      Job Market
    </v-btn>-->
    <!--<v-btn flat color="indigo darken-1" to="/blog">
      Blog
    </v-btn> -->
    <v-spacer></v-spacer>
  </v-toolbar>
</nav>

</template>


<script>
  export default {

  }
</script>
